import { normalizeHost } from './host'
import {
  coerceTenantIdentity,
  sameTenantIdentity,
  type TenantIdentity
} from './identity'

/**
 * O host inteiro entra na chave, não o slug: é o que o script inline conhece
 * antes de qualquer módulo carregar, e é o que isola dois eventos abertos no
 * mesmo navegador.
 */
export const TENANT_IDENTITY_STORAGE_PREFIX = 'evnttz.tenant-identity:'

export function tenantIdentityStorageKey(host: string): string {
  return `${TENANT_IDENTITY_STORAGE_PREFIX}${normalizeHost(host)}`
}

/**
 * O acesso ao objeto está dentro do `try`, e não só a leitura: em alguns
 * navegadores (Safari privado, site data bloqueado) o getter **lança**.
 */
function storage(): Storage | null {
  try {
    if (typeof window === 'undefined') return null
    return window.localStorage
  } catch {
    return null
  }
}

export function readTenantIdentity(host: string): TenantIdentity | null {
  const store = storage()
  if (!store) return null

  try {
    const raw = store.getItem(tenantIdentityStorageKey(host))
    if (!raw) return null
    return coerceTenantIdentity(JSON.parse(raw))
  } catch {
    return null
  }
}

/**
 * Grava só quando o conteúdo difere (design D4), e devolve `true` quando
 * escreveu. Cota estourada e armazenamento indisponível viram "não escreveu":
 * nenhum boot pode quebrar por não conseguir gravar aparência.
 */
export function writeTenantIdentity(
  host: string,
  identity: TenantIdentity | null | undefined
): boolean {
  if (!identity) return false

  const store = storage()
  if (!store) return false

  if (sameTenantIdentity(readTenantIdentity(host), identity)) return false

  try {
    store.setItem(tenantIdentityStorageKey(host), JSON.stringify(identity))
    return true
  } catch {
    return false
  }
}

export function clearTenantIdentity(host: string): void {
  const store = storage()
  if (!store) return

  try {
    store.removeItem(tenantIdentityStorageKey(host))
  } catch {
    /* ausência de armazenamento não é erro de aplicação */
  }
}
